import React from "react";
import { Row, Col } from "rsuite";
import PropTypes from "prop-types";
import CoffeeIcon from "../../assets/img/coffee.svg";
import CoinHandIcon from "../../assets/img/coin-hand.svg";

// Breakfast / Refundable amenity rows shown under the stacked promotions
// card. Mirrors the legacy PromotionSummary markup (same global classes from
// promotion-summary.scss) so pilot and non-pilot panels look identical here.
const RateplanAmenities = ({ isBreakfastIncluded, isRefundable }) => (
  <>
    {isBreakfastIncluded ? (
      <Row className="mt-4">
        <Col xs={3}>
          <div className="breakast-wrapper-icon">
            <img src={CoffeeIcon} alt="Food icon" className="breakfast-icon" />
          </div>
        </Col>
        <Col xs={21} className="promotion-label">
          Bed & Breakfast included
        </Col>
      </Row>
    ) : null}

    {isRefundable ? (
      <Row className="mt-4">
        <Col xs={3}>
          <div className="coin-hand-wrapper-icon">
            <img
              src={CoinHandIcon}
              alt="promotion icon"
              className="coin-hand-icon"
            />
          </div>
        </Col>
        <Col xs={21} className="promotion-label">
          Refundable
        </Col>
      </Row>
    ) : null}
  </>
);

RateplanAmenities.propTypes = {
  isBreakfastIncluded: PropTypes.bool,
  isRefundable: PropTypes.bool,
};

export default RateplanAmenities;
